import { Thunk, thunk, Action, action } from 'easy-peasy'
import api from '../api'
import { RateSet } from '@libs/types/generated/rates-research-api'
import { StoreModel } from '.'

export interface RatesModel {
  rateSets: RateSet[]
  setRateSets: Action<RatesModel, RateSet[]>
  fetchRateSets: Thunk<RatesModel, undefined, any, StoreModel>
  createRateSet: Thunk<RatesModel>
}

const rates: RatesModel = {
  // State
  rateSets: [],

  // actions
  setRateSets: action((state, payload) => {
    state.rateSets = payload
  }),

  // thunks
  fetchRateSets: thunk(async (actions, _, { getStoreActions }) => {
    const { data } = await api.rateSets.getAll()
    let rateSets: RateSet[] = data.sort((a: RateSet, b: RateSet) => b.id - a.id)

    // get userHasRole from auth store
    const { userHasRole } = getStoreActions().auth

    // check if user has 'rates' role which is the role of admins
    const isStaff = await userHasRole('staff')

    // if user is not 'staff', filter out 'credit-cards' rate sets
    if (!isStaff) {
      rateSets = rateSets.filter(rateSet => rateSet.vertical !== 'credit-cards')
    }

    actions.setRateSets(rateSets)
  }),

  createRateSet: thunk((actions, payload) => {
    const data: any = payload || {}
    data.status = data.bypass_qc ? 'PUBLISHED_QC' : 'NEED_QC'

    return api.rateSets.create(payload)
  })
}

export default rates
